/**
 * Account UI
 * DOM updates for account section. Extracted to avoid circular imports.
 */

/* global document */

import type { AuthSession } from "../../shared/auth/types";

export function refreshAccountUI(session: AuthSession | null): void {
  const signedOutEl = document.getElementById("account-signed-out");
  const signedInEl = document.getElementById("account-signed-in");
  const emailEl = document.getElementById("account-email");
  const userIdEl = document.getElementById("account-user-id");

  if (!signedOutEl || !signedInEl) return;

  if (session) {
    signedOutEl.style.display = "none";
    signedInEl.style.display = "";
    if (emailEl) emailEl.textContent = session.user.email;
    if (userIdEl) userIdEl.textContent = session.user.id;
  } else {
    signedOutEl.style.display = "";
    signedInEl.style.display = "none";
    if (emailEl) emailEl.textContent = "";
    if (userIdEl) userIdEl.textContent = "";
  }
}

export function showOtpFallback(): void {
  const link = document.getElementById("otp-fallback-link");
  if (link) {
    link.style.display = "";
  }
}
